/* Below lg: the sidebar's navigation in a start-side drawer, closing on navigation. */
import { useTranslation } from 'react-i18next'
import { Drawer } from '@/components/ui'
import { LanguageSwitch } from './LanguageSwitch'
import { LogoLockup } from './Logo'
import { OrgSwitcher } from './OrgSwitcher'
import { NavList, SidebarFooter } from './Sidebar'

export function MobileNav({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const { t } = useTranslation('shell')
  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      side="start"
      size="sm"
      title={t('a11y.mainNav')}
      hideTitle
      className="bg-app-sidebar"
    >
      <div className="flex min-h-full flex-col gap-6 px-3 pt-5 pb-6">
        <div className="px-2.5">
          <LogoLockup className="h-[22px] w-auto" />
        </div>
        <div className="rounded-2xl bg-surface p-2 ring-1 ring-hairline">
          <OrgSwitcher />
        </div>
        <div className="flex-1">
          <NavList onNavigate={() => onOpenChange(false)} />
        </div>
        <div className="flex flex-col gap-3">
          <LanguageSwitch className="w-fit" />
          <SidebarFooter />
        </div>
      </div>
    </Drawer>
  )
}
